import { Component, OnInit } from '@angular/core';
import 'rxjs/add/operator/toPromise';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ModalService } from '../../../../shared/modules/modal/modal.service';
import { CompSearchService } from '../../../../shared/services/comp-search.service';
import { NotificationService } from '../../../../shared/services/notifications.service';

import { ClosableModalWithErrorResponseModel } from '../../../../shared/components/base/closable-modal-with-error-response-model';
import { TuneCompSearchModalData, CompSearchData } from '../../../../shared/models';
import { Observable } from 'rxjs';

@Component({
  selector: 'save-comp-search-modal',
  templateUrl: './save-comp-search-modal.component.html',
  styleUrls: ['../tune-comparable-search.component.css'],
})
export class SaveCompSearchModalComponent
  extends ClosableModalWithErrorResponseModel<any>
  implements OnInit {
  
  saveCompSearchForm: FormGroup;
  data: TuneCompSearchModalData;
  isFormValid: boolean = false;
  compSearchNameExists: boolean;
  savingCompSearch: boolean = false;

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    private _formBuilder: FormBuilder,
    private _compSearchService: CompSearchService
  ) {
    super(notificationService, modalService);
    this.compSearchNameExists = false;
  
  }

  ngOnInit(): void {
    this.createForm();
  }

  createForm(): void {
    this.saveCompSearchForm = this._formBuilder.group({
      compSearchName: ['', Validators.required]
    });
  }

  getCompSearchNameFormControl(): AbstractControl { return this.saveCompSearchForm.get('compSearchName'); }
 
  validateFormAndSave(): void {
    this.savingCompSearch = true;
    this.nameIsAlreadyInUse().subscribe((isInUse: boolean) => {
      this.compSearchNameExists = isInUse;
      if (this.isValidForm() && !isInUse) {
        this.saveCompSearch();
      } else {
        this.savingCompSearch = false;
      }
    });
  }

  isValidForm(): boolean {
    return this.saveCompSearchForm.valid;
  }

  nameIsAlreadyInUse(): Observable<boolean> {
    const compSearchName: string = this.getCompSearchNameFormControl().value;
    return this.data.isGlobal ? this._compSearchService.compSearchGlobalNameIsUsed(compSearchName) : this._compSearchService.compSearchNameIsUsed(this.data.tenantId, compSearchName);
  }

  private saveCompSearch(): void {
    const payload: CompSearchData = {
      compSearchId: this.data.compSearchId,
      compSearchName: this.getCompSearchNameFormControl().value,
      jurisdictionId: this.data.jurisdictionId,
      containerId: this.data.containerId,
      tenantId: this.data.tenantId
    };
    if (this.data.isGlobal) {
      this._compSearchService.saveGlobalCompSearch(payload).subscribe(() => {
        this.onSavedSuccess();
      });
    } else {
      this._compSearchService.saveCompSearch(payload).subscribe(() => {
        this.onSavedSuccess();
      });
    }
  }

  private onSavedSuccess() {
    this.savingCompSearch = false;
    this.success();
    this.closeAllModals();
  }

  exitModal(): void {
    this.closeAllModals();
  }
}
